import { Activity, Building2, Calculator, Eye, PauseCircle, Users } from "lucide-react";
import { fmtInt } from "@/lib/format";

const CARDS = [
  ["active_customers", "Aktive kunder", Building2, "text-sky-700 bg-sky-50"],
  ["paused_customers", "Pauset", PauseCircle, "text-amber-700 bg-amber-50"],
  ["total_users", "Brukere totalt", Users, "text-slate-700 bg-slate-100"],
  ["active_users_30d", "Innloggede brukere 30 d", Activity, "text-emerald-700 bg-emerald-50"],
  ["views_30d", "Visninger 30 d", Eye, "text-sky-700 bg-sky-50"],
  ["calcs_30d", "Beregninger 30 d", Calculator, "text-indigo-700 bg-indigo-50"],
];

export const StatCards = ({ data }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
    {CARDS.map(([k, label, Icon, tone], i) => (
      <div key={k} className="bg-white border border-slate-200 rounded-lg p-4 fade-up" style={{ animationDelay: `${i * 50}ms` }} data-testid={`stat-${k}`}>
        <div className={`w-8 h-8 rounded-md flex items-center justify-center ${tone}`}><Icon className="w-4 h-4" /></div>
        <div className="mt-3 font-display text-2xl font-semibold text-slate-900 font-num" data-testid={`stat-${k}-value`}>{data ? fmtInt(data[k]) : "–"}</div>
        <div className="text-xs text-slate-500 mt-0.5">{label}</div>
      </div>
    ))}
  </div>
);
